import { Box, Container, Grid } from '@mui/material'
import { SectionHeading } from '@/components/common'
import { trustContent } from '@/data/content'
import { ValueCard, valueIcons } from './ValueCard'

/**
 * Trust Section Component
 * Showcases value propositions with 4 cards
 */
export const TrustSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" underline>
          {trustContent.heading}
        </SectionHeading>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {trustContent.cards.map((card, index) => {
            // Get corresponding icon from mapping
            const IconComponent = valueIcons[card.title as keyof typeof valueIcons]
            
            return (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <ValueCard
                  icon={IconComponent}
                  title={card.title}
                  description={card.description}
                />
              </Grid>
            )
          })}
        </Grid>
      </Container>
    </Box>
  )
}
